module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    staticClass: "minHeight"
  }, [_c('Loader')], 1) : _c('div', {
    staticClass: "exclusive-wrapper minHeight"
  }, [(_vm.bannerPlaceHolderForNewExclusiveRevamp) ? _c('div', [_c('exclusive-revamp'), _vm._v(" "), (_vm.isNotifyVisible) ? _c('exclusive-modal', {
    attrs: {
      "addExclusive": _vm.addExclusive,
      "togglePopup": _vm.togglePopup,
      "exclusiveAdded": _vm.exclusiveAdded,
      "removeExcFromCart": _vm.removeExcFromCart
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNotifyVisible && this.now < this.launchDate) ? _c('notify-modal', {
    attrs: {
      "notify": _vm.notify
    }
  }) : _vm._e()], 1) : _c('div', [(_vm.bannerPlaceHolderExc && _vm.bannerPlaceHolderExc.status) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderExc && _vm.bannerPlaceHolderExc.styles,
      "bannerMsg": _vm.bannerPlaceHolderExc && _vm.bannerPlaceHolderExc.text
    }
  }) : _vm._e(), _vm._v(" "), (_vm.exclusiveUser && _vm.exclusiveDetails && _vm.exclusiveDetails.expire_in >= 0) ? _c('div', {
    staticClass: "exc-section-one-wrapper is_Desktop"
  }, [_c('div', {
    staticClass: "exc-mem-section-one container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "fbold userHead"
  }, [_c('p', {
    staticClass: "exc-mem-name"
  }, [_vm._v("\n                " + _vm._s(_vm.username) + "\n                "), _c('img', {
    staticClass: "crownImgMain",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/userCrown.png",
      "alt": "Crown"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "total-savings-div"
  }, [_c('p', {
    staticClass: "total-savings"
  }, [_vm._v("Total " + _vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings') + " Till Now: " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.exclusiveDetails.exclusive_savings))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row exc-mem-info"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.exclusiveDetails.membership_type === 'MONTHLY') ? _c('p', {
    staticClass: "exc-active-plan"
  }, [_vm._v("Active plan : 1 Month")]) : (_vm.exclusiveDetails.membership_type === 'ANNUAL') ? _c('p', {
    staticClass: "exc-active-plan"
  }, [_vm._v("Active plan : 12 Months")]) : _c('p', {
    staticClass: "exc-active-plan"
  }, [_vm._v("Active plan : 3 Months")]), _vm._v(" "), _c('p', {
    staticClass: "exc-member-since"
  }, [_vm._v("Member since " + _vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.exclusive_since && _vm.exclusiveDetails.exclusive_since.split(' ')[0])), _c('sup', [_vm._v(_vm._s(_vm.exclusiveDetails.exclusive_since_sup))]), _vm._v(" " + _vm._s(_vm.exclusiveDetails.exclusive_since.split(' ')[1]) + " " + _vm._s(_vm.exclusiveDetails.exclusive_since.split(' ')[2]))]), _vm._v(" "), _c('p', {
    staticClass: "exc-plan-valid-till"
  }, [_vm._v("Plan Valid till " + _vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.expiry_date && _vm.exclusiveDetails.expiry_date.split(' ')[0])), _c('sup', [_vm._v(_vm._s(_vm.exclusiveDetails.expiry_date_sup))]), _vm._v(" " + _vm._s(_vm.exclusiveDetails.expiry_date.split(' ')[1]) + " " + _vm._s(_vm.exclusiveDetails.expiry_date.split(' ')[2]))])])]), _vm._v(" "), (_vm.exclusiveDetails.show_upgrade_plan && !_vm.CHECK_PRODUCT_MATCHES) ? _c('div', {
    staticClass: "row exc-mem-update-head"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "exc-upgrade-plan"
  }, [_vm._v("EXTEND YOUR PLAN")])])]) : _vm._e(), _vm._v(" "), (_vm.exclusiveDetails.show_upgrade_plan && !_vm.CHECK_PRODUCT_MATCHES) ? _c('div', {
    staticClass: "row exc-mem-update-div",
    staticStyle: {
      "width": "96%"
    }
  }, [_c('div', {
    staticClass: "col-7",
    staticStyle: {
      "padding-right": "0px !important"
    }
  }, [_c('p', {
    staticClass: "exc-mem-exceede-time"
  }, [_vm._v("12 months more at just RS "), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("199")]), _vm._v(" 99")])]), _vm._v(" "), (_vm.exclusiveDetails.show_upgrade_plan) ? _c('div', {
    staticClass: "col-5",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('p', {
    staticClass: "exc-mem-update-btn",
    on: {
      "click": function($event) {
        _vm.upgradeMembershipToCart(_vm.EXCLUSIVE_PRODUCTS_UPGRADE.prod_id)
      }
    }
  }, [_vm._v("Extend Now")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "exc-days-left-head",
    staticStyle: {
      "margin": "0px",
      "line-height": "20px"
    }
  }, [_vm._v("Days Left As An")]), _vm._v(" "), _c('p', {
    staticClass: "exc-days-left-head",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("Exclusive Member")])])]), _vm._v(" "), (_vm.exclusiveDetails) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "col-6",
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('circle-counter', {
    attrs: {
      "size": "10rem",
      "dash-spacing": 0,
      "stroke-width": 8,
      "active-width": 8,
      "dash-count": 100,
      "stroke": parseInt(_vm.exclusiveDetails.expire_in) === parseInt(_vm.exclusiveDetails.expire_days) ? '#122643' : '#aba6a6',
      "active-stroke": "#122643",
      "active-count": (parseInt(_vm.exclusiveDetails.expire_in) / parseInt(_vm.exclusiveDetails.expire_days)) * 100,
      "reverse": false,
      "text": ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "exc-days-left"
  }, [_vm._v(_vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.expire_in))]), _vm._v(" "), _c('p', {
    staticClass: "days-left"
  }, [_vm._v("days left")])], 1)]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.exclusiveUser && _vm.exclusiveDetails.expire_in >= 0) ? _c('div', {
    staticClass: "exc-section-one-wrapper is_Mobile"
  }, [_c('div', {
    staticClass: "exc-mem-section-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "fbold userHead"
  }, [_c('img', {
    staticClass: "crownImgMain",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/userCrown.png",
      "alt": "Crown"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "exc-mem-name"
  }, [_vm._v("\n                " + _vm._s(_vm.username) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "total-savings-div"
  }, [_c('p', {
    staticClass: "total-savings"
  }, [_vm._v("Total " + _vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings') + " Till Now: " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.exclusiveDetails.exclusive_savings))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row exc-mem-info"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.exclusiveDetails.membership_type === 'MONTHLY') ? _c('p', {
    staticClass: "exc-active-plan"
  }, [_vm._v("Active plan : 1 Month")]) : (_vm.exclusiveDetails.membership_type === 'ANNUAL') ? _c('p', {
    staticClass: "exc-active-plan"
  }, [_vm._v("Active plan : 12 Months")]) : _c('p', {
    staticClass: "exc-active-plan"
  }, [_vm._v("Active plan : 3 Months")]), _vm._v(" "), _c('p', {
    staticClass: "exc-member-since"
  }, [_vm._v("Member since " + _vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.exclusive_since && _vm.exclusiveDetails.exclusive_since.split(' ')[0])), _c('sup', [_vm._v(_vm._s(_vm.exclusiveDetails.exclusive_since_sup))]), _vm._v(" " + _vm._s(_vm.exclusiveDetails.exclusive_since.split(' ')[1]) + " " + _vm._s(_vm.exclusiveDetails.exclusive_since.split(' ')[2]))]), _vm._v(" "), _c('p', {
    staticClass: "exc-plan-valid-till"
  }, [_vm._v("Plan Valid till " + _vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.expiry_date && _vm.exclusiveDetails.expiry_date.split(' ')[0])), _c('sup', [_vm._v(_vm._s(_vm.exclusiveDetails.expiry_date_sup))]), _vm._v(" " + _vm._s(_vm.exclusiveDetails.expiry_date.split(' ')[1]) + " " + _vm._s(_vm.exclusiveDetails.expiry_date.split(' ')[2]))])])]), _vm._v(" "), (_vm.exclusiveDetails.show_upgrade_plan && !_vm.CHECK_PRODUCT_MATCHES) ? _c('div', {
    staticClass: "row exc-mem-update-head"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('span', {
    staticClass: "exc-mem-upgrade-plan"
  }, [_vm._v("\n                  EXTEND YOUR PLAN     \n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.exclusiveDetails.show_upgrade_plan && !_vm.CHECK_PRODUCT_MATCHES) ? _c('div', {
    staticClass: "row exc-mem-update-div"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('p', {
    staticClass: "exc-mem-exceede-time"
  }, [_vm._v("12 months more at just RS "), _c('span', {
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("199")]), _vm._v(" 99")])]), _vm._v(" "), (_vm.exclusiveDetails.show_upgrade_plan) ? _c('div', {
    staticClass: "col-4",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('p', {
    staticClass: "exc-mem-update-btn",
    on: {
      "click": function($event) {
        _vm.upgradeMembershipToCart(_vm.EXCLUSIVE_PRODUCTS_UPGRADE.prod_id)
      }
    }
  }, [_vm._v("Extend Now")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 exc-mem-tracker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "text-align": "start",
      "padding": "10px",
      "margin-bottom": "20px"
    }
  }, [_c('p', {
    staticClass: "exc-days-left-head"
  }, [_vm._v("Days Left As An Exclusive Member")])])]), _vm._v(" "), (_vm.exclusiveDetails) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "col-6",
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('circle-counter', {
    attrs: {
      "size": "10rem",
      "dash-spacing": 0,
      "stroke-width": 8,
      "active-width": 8,
      "dash-count": 100,
      "stroke": parseInt(_vm.exclusiveDetails.expire_in) === parseInt(_vm.exclusiveDetails.expire_days) ? '#122643' : '#aba6a6',
      "active-stroke": "#122643",
      "active-count": (parseInt(_vm.exclusiveDetails.expire_in) / parseInt(_vm.exclusiveDetails.expire_days)) * 100,
      "text": ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "exc-days-left"
  }, [_vm._v(_vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.expire_in))]), _vm._v(" "), _c('p', {
    staticClass: "days-left"
  }, [_vm._v("days left")])], 1)]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.exclusiveDetails && _vm.exclusiveDetails.expire_in < 0 || !_vm.exclusiveUser) ? _c('div', {
    staticClass: "exc-section-one-wrapper"
  }, [(_vm.isExclusive) ? _c('div', {
    staticClass: "exc-section-one container-fluid"
  }, [_c('div', {
    staticClass: "row click-to-add"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "sec-one-discount-header"
  }, [_vm._v("BIG DISCOUNTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "row click-to-add"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "sec-one-discount-content"
  }, [_vm._v("ON ALL PRODUCTS EVERY DAY.")])])])]) : _c('div', {
    staticClass: "exc-section-one container-fluid"
  }, [_c('div', {
    staticClass: "row click-to-add"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "sec-one-discount-header"
  }, [_vm._v("BIG DISCOUNTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "row click-to-add"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "sec-one-discount-content"
  }, [_vm._v("ON ALL PRODUCTS EVERY DAY.")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container mt40 exclusive-features"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-10 text-left"
  }, [_c('div', {
    staticClass: "exc-mem-heading"
  }, [_c('span', {
    staticClass: "fbold text-left benefitsHeading"
  }, [_vm._v(" Exclusive Member Benefits\n              "), _c('img', {
    staticClass: "crownImg",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/crown.png",
      "alt": "Crown"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mtb20"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-md-4 eximgDiv"
  }, [_c('img', {
    staticClass: "eximg",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/rupeeDiscount.png",
      "alt": "Big Discounts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-7"
  }, [_c('p', {
    staticClass: "text-left fbold cHeading"
  }, [_vm._v("DISCOUNTED PRICES")]), _vm._v(" "), _c('div', {
    staticClass: "line mb10"
  }, [_c('div', {
    staticClass: "excBenefitCircle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-left cDesc"
  }, [_vm._v("\n                  BIG discounts on ALL products every day. You never have to wait for a sale again.\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-md-4 eximgDiv"
  }, [_c('img', {
    staticClass: "eximg",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/earlyAcc.png",
      "alt": "Early Access"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-7"
  }, [_c('p', {
    staticClass: "text-left fbold cHeading"
  }, [_vm._v("EARLY  ACCESS")]), _vm._v(" "), _c('div', {
    staticClass: "line mb10"
  }, [_c('div', {
    staticClass: "excBenefitCircle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-left cDesc"
  }, [_vm._v("\n                  Be the first to know about select product and designs.\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mtb20"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-md-4 eximgDiv"
  }, [_c('img', {
    staticClass: "eximg",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/free.png",
      "alt": "Free Delivery"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-7"
  }, [_c('p', {
    staticClass: "text-left fbold cHeading"
  }, [_vm._v("FREE DELIVERY")]), _vm._v(" "), _c('div', {
    staticClass: "line mb10"
  }, [_c('div', {
    staticClass: "excBenefitCircle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-left cDesc"
  }, [_vm._v("\n                  Your shipping charges are on the house.   \n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 col-md-4 eximgDiv"
  }, [_c('img', {
    staticClass: "eximg",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/box.png",
      "alt": "Shipping"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-7"
  }, [_c('p', {
    staticClass: "text-left fbold cHeading"
  }, [_vm._v("PRIORITISED ORDER "), _c('br'), _vm._v(" PROCESSING ")]), _vm._v(" "), _c('div', {
    staticClass: "line mb10"
  }, [_c('div', {
    staticClass: "excBenefitCircle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-left cDesc"
  }, [_vm._v("\n                We ship your orders before everyone else.\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "exc-section-two-wrapper"
  }, [_c('div', {
    staticClass: "exc-section-two"
  }, [(!_vm.isExclusive) ? _c('ExclusiveCard', {
    attrs: {
      "addMembershipToCart": _vm.addMembershipToCart,
      "addExclusive": _vm.addExclusive
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isExclusive && !_vm.exclusiveUser) ? _c('div', {
    staticClass: "exclusive-congrats-msg"
  }, [_vm._v("Congratulations, You're a member!")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row exc-member-banner"
  }, [_c('div', {
    staticClass: "col-12 exc-saving"
  }, [_c('p', {
    staticClass: "saving-msg"
  }, [_vm._v("Average Exclusive Member Savings: " + _vm._s(_vm.currencySymbol) + "2,600/ Year")])])]), _vm._v(" "), (!_vm.exclusiveUser && _vm.exclusivePricelist && _vm.exclusivePricelist.length > 0) ? _c('div', {
    staticClass: "exc-section-three-wrapper"
  }, [_c('div', {
    staticClass: "exc-section-three container is_Desktop"
  }, [_c('div', {
    staticClass: "section-title-wrapper",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('span', {
    staticClass: "section-price-comparison"
  }, [_vm._v("\n            PRICE COMPARISON\n          ")])]), _vm._v(" "), _c('carousel', {
    staticClass: "exc-cat-carousel",
    attrs: {
      "per-page": 4,
      "loop": true,
      "mouse-drag": true,
      "autoplay": false,
      "autoplayTimeout": 3000,
      "paginationActiveColor": "#e66a51",
      "paginationColor": "#646769"
    }
  }, _vm._l((this.exclusivePricelist), function(value, index) {
    return _c('slide', {
      key: index,
      staticClass: "exc-cat-slider"
    }, [_c('ExclusiveCatCards', {
      staticClass: "exc-cat-card exc-card-desk",
      attrs: {
        "value": value
      }
    })], 1)
  }))], 1), _vm._v(" "), (_vm.exclusivePricelist && _vm.exclusivePricelist.length > 0) ? _c('div', {
    staticClass: "exc-section-three container is_Mobile"
  }, [_c('div', {
    staticClass: "section-title-wrapper",
    staticStyle: {
      "padding-bottom": "30px"
    },
    attrs: {
      "id": "faqs"
    }
  }, [_c('span', {
    staticClass: "section-price-comparison"
  }, [_vm._v("\n            PRICE COMPARISON      \n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mobile_carousel"
  }, _vm._l((this.exclusivePricelist), function(value, index) {
    return _c('div', {
      key: index
    }, [_c('ExclusiveCatCards', {
      staticClass: "exc-cat-card",
      attrs: {
        "value": value
      }
    })], 1)
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isExclusive) ? _c('exclusiveAddTOCart', {
    attrs: {
      "addMembershipToCart": _vm.addMembershipToCart,
      "togglePopup": _vm.togglePopup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNotifyVisible) ? _c('exclusive-modal', {
    attrs: {
      "addExclusive": _vm.addExclusive,
      "togglePopup": _vm.togglePopup,
      "exclusiveAdded": _vm.exclusiveAdded,
      "removeExcFromCart": _vm.removeExcFromCart
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNotifyVisible && this.now < this.launchDate) ? _c('notify-modal', {
    attrs: {
      "notify": _vm.notify
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e02cfb5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exclusive.vue
// module id = 2402
// module chunks = 26